import React from "react"
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import "./styles.scss"

export default function AboutUsComponent() {
  return (
    <>
      <HeaderComponent />

      <main id="main" className="site-main content-no-spacing about__wrapper">
        <div className="content">
          <div className="clearfix">
            <section
              id="page-title"
              className="page-title-ml content-top-spacing"
            >
              <div className="wrapper">
                <div className="title">
                  <h1 className="large">About Us</h1>
                </div>

                <div className="title-opacity">
                  <div className="title-opacity-text">About</div>
                </div>
              </div>
            </section>

            <div id="img" className="block spacer p-top-xl wrapper-normal">
              <div className="wrapper">
                <div className="img-size-1">
                  <div className="img object-fit">
                    <div className="object-fit-cover">
                      <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/02_img.jpg" alt="Team" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section
              id="about-us"
              className="block spacer p-top-xl p-bottom-xl"
            >
              <div className="wrapper">
                <div className="title">
                  <h6 className="text-primary text-uppercase">About Us</h6>
                </div>

                <div className="row gutter-width-md with-pb-md">
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="description-2">
                      <h2>
                        Keep Your Business Safe & Ensure High Availability
                      </h2>
                    </div>

                    <div className="signature spacer m-top-lg">
                      {/* <div className="signature-img">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/23_img.png" alt="Signature" />
                      </div> */}

                      <div className="signature-content">
                        <h5 className="signature-name">Ankit Gupta</h5>
                        <p className="signature-position">CEO & CO FOUNDER</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="description-2">
                      <p>
                      Codebubble provides brands with a simpler means of building and growing their businesses.
They get to reach customers and clients faster, attend to their needs more efficiently, and improve their services daily.
Codebubble is a software development company focused on helping brands succeed in the digital space by building their online presence and connecting them with their target audience through professional and high effectively solutions.
The company is India based and has a local presence in MP, where they provide various high-end software services. These include web development, mobile app development, CMS Development, Angular, Vue.js development, digital marketing services, social media services, visual communication, content creation, and digital strategy.
                      </p>
                    </div>

                    <div className="description-2 spacer p-top-lg">
                      <p>
                        Marketing consultant is an advisor who works with
                        companies to create and implement marketing strategies.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="icon-list">
                  <div className="icon-list-items">
                    <div className="icon-list-item">
                      <p>
                        <span className="d-flex">
                          <i className="fas fa-check"></i>
                          <span>Constant Improvement</span>
                        </span>
                      </p>
                    </div>

                    <div className="icon-list-item">
                      <p>
                        <span className="d-flex">
                          <i className="fas fa-check"></i>
                          <span>Commitment to Customers</span>
                        </span>
                      </p>
                    </div>

                    <div className="icon-list-item">
                      <p>
                        <span className="d-flex">
                          <i className="fas fa-check"></i>
                          <span>Best Quality You Can Get</span>
                        </span>
                      </p>
                    </div>

                    <div className="icon-list-item">
                      <p>
                        <span className="d-flex">
                          <i className="fas fa-check"></i>
                          <span>30 Days Money Back Warranty</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              id="team-members"
              className="block bg-white-before spacer p-top-xl p-bottom-xl"
            >
              <div className="wrapper">
                <div className="title">
                  <h6 className="text-primary text-uppercase">Meet our team</h6>
                </div>

                <div className="title-opacity">
                  <div className="title-opacity-text">Team</div>
                </div>

                <div className="description">
                  <h2>We are Business Consulting Professionals</h2>
                </div>

                <div className="row gutter-width-md with-pb-md spacer p-top-lg">
                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="team-member">
                      <div className="team-member-top">
                        <div className="img object-fit">
                          <div className="object-fit-cover">
                            <img
                              src="/img/033_img.jpg"
                              alt="Ankit Gupta"
                            />
                          </div>
                        </div>

                        <div className="team-member-position">
                          <p>CEO & CO FOUNDER</p>
                        </div>
                      </div>

                      <div className="team-member-content">
                        <h4 className="team-member-t-head">Ankit Gupta</h4>

                        {/* <div className="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav className="team-member-nav-items">
                        <ul className="nav">
                          <li className="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/ankit25/"
                            >
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/happygupta25/"
                            >
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/happygupta25/"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="team-member">
                      <div className="team-member-top">
                        <div className="img object-fit">
                          <div className="object-fit-cover">
                            <img
                              src="/img/044_img.jpg"
                              alt="Shuchi Gupta"
                            />
                          </div>
                        </div>

                        <div className="team-member-position">
                          <p>TEAM LEAD – ANDROID</p>
                        </div>
                      </div>

                      <div className="team-member-content">
                        <h4 className="team-member-t-head">Shuchi Gupta</h4>

                        {/* <div className="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav className="team-member-nav-items">
                        <ul className="nav">
                          <li className="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/shuchigupta4"
                            >
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/shuchi-gupta-4067865a/"
                            >
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/shuchigupta4/"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="team-member">
                      <div className="team-member-top">
                        <div className="img object-fit">
                          <div className="object-fit-cover">
                            <img
                              src="/img/055_img.jpg"
                              alt="Priyank Bahre"
                            />
                          </div>
                        </div>

                        <div className="team-member-position">
                          <p>BUSINESS MANAGEMENT</p>
                        </div>
                      </div>

                      <div className="team-member-content">
                        <h4 className="team-member-t-head">Priyank Bahre</h4>

                        {/* <div className="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav className="team-member-nav-items">
                        <ul className="nav">
                          <li className="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/priyank.bahre"
                            >
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/priyank-bahre-0a245b34/"
                            >
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/priyankbah/"
                            >
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <section
              id="testimonials"
              className="block bg-dark spacer p-top-xl p-bottom-xl"
            >
              <div className="wrapper">
                <div className="title">
                  <h6 className="text-primary text-uppercase">Testimonials</h6>
                </div>

                <div className="description text-tertiary">
                  <h2>Our Happy Customers Reviews</h2>
                </div>

                <div className="adv-slider-reviews text-tertiary">
                  <div className="adv-slider-reviews-img">
                    <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/11_img.png" alt="Icon" />
                  </div>

                  <div className="adv-swiper-container reviews-text">
                    <div className="adv-swiper-wrapper reviews-text-items">
                      <div className="adv-swiper-slide reviews-text-item">
                        <div className="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>

                      <div className="adv-swiper-slide reviews-text-item">
                        <div className="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>

                      <div className="adv-swiper-slide reviews-text-item">
                        <div className="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center thumbs">
                    <div className="adv-swiper-container reviews-thumbs">
                      <div className="adv-swiper-wrapper reviews-thumbs-items">
                        <div
                          className="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Tommy Andersen"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/12_img.png"
                            alt="Tommy Andersen"
                          />
                        </div>

                        <div
                          className="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Arthur Hopin"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/12_img.png"
                            alt="Arthur Hopin"
                          />
                        </div>

                        <div
                          className="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Rosie Ford"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/12_img.png"
                            alt="Rosie Ford"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="reviews-results">
                      <h6 className="reviews-name" id="reviews-name">
                        Tommy Andersen
                      </h6>
                      <p className="reviews-positions" id="reviews-positions">
                        CEO at Company
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <div id="clients" className="block bg-white">
              <div className="wrapper">
                <div className="clients">
                  <div className="clients-items">
                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Adveits" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Swiger" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img
                          src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png"
                          alt="The mandala community"
                        />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div className="clients-item">
                      <div className="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Adveits" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          </div>
        </div>
      </main>

      <FooterComponent />
    </>
  )
}
